import React, { createContext, useState, useContext } from 'react';

const SubMenuContext = createContext();

export const SubMenuProvider = ({ children }) => {
  // Initialize Sub Menu state with an empty value
  const [subMenuOpen, setSubMenuOpen] = useState(null);

  return (
    <SubMenuContext.Provider value={{ subMenuOpen, setSubMenuOpen }}>
      {children}
    </SubMenuContext.Provider>
  );
};

export const useSubMenu = () => useContext(SubMenuContext);
